import { apiKeyClient } from '@better-auth/api-key/client';
import { adminClient, organizationClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

export const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  fetchOptions: {
    credentials: 'include', // Important: include cookies in cross-origin requests
  },
  plugins: [adminClient(), apiKeyClient(), organizationClient()],
});
